import listActions from 'src/modules/userEntitlement/list/userEntitlementListActions';
import UserEntitlementService from 'src/modules/userEntitlement/userEntitlementService';
import Errors from 'src/modules/shared/error/errors';
import { i18n } from 'src/i18n';
import { getHistory } from 'src/modules/store';
import Message from 'src/view/shared/message';

const prefix = 'USERENTITLEMENT_DESTROY';

const userEntitlementDestroyActions = {
  DESTROY_STARTED: `${prefix}_DESTROY_STARTED`,
  DESTROY_SUCCESS: `${prefix}_DESTROY_SUCCESS`,
  DESTROY_ERROR: `${prefix}_DESTROY_ERROR`,

  DESTROY_ALL_STARTED: `${prefix}_DESTROY_ALL_STARTED`,
  DESTROY_ALL_SUCCESS: `${prefix}_DESTROY_ALL_SUCCESS`,
  DESTROY_ALL_ERROR: `${prefix}_DESTROY_ALL_ERROR`,

  doDestroy: (id) => async (dispatch) => {
    try {
      dispatch({
        type: userEntitlementDestroyActions.DESTROY_STARTED,
      });

      await UserEntitlementService.destroyAll([id]);

      dispatch({
        type: userEntitlementDestroyActions.DESTROY_SUCCESS,
      });

      Message.success(
        i18n('entities.userEntitlement.destroy.success'),
      );

      dispatch(listActions.doFetchCurrentFilter());

      // getHistory().push('/user-entitlement');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: userEntitlementDestroyActions.DESTROY_ERROR,
      });
    }
  },

  doDestroyAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type: userEntitlementDestroyActions.DESTROY_ALL_STARTED,
      });

      await UserEntitlementService.destroyAll(ids);

      dispatch({
        type: userEntitlementDestroyActions.DESTROY_ALL_SUCCESS,
      });

      if (listActions) {
        dispatch(listActions.doClearAllSelected());
        dispatch(listActions.doFetchCurrentFilter());
      }

      Message.success(
        i18n('entities.userEntitlement.destroyAll.success'),
      );

      getHistory().push('/user-entitlement');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: userEntitlementDestroyActions.DESTROY_ALL_ERROR,
      });
    }
  },
};

export default userEntitlementDestroyActions;
